<div class="tw-flex tw-items-center tw-flex-wrap tw-gap-[8px]">
  <span>{{ 'iss-wo-common.recurrence-schedule.recurrence-type.day' | translate }}</span>
  <ng-content select="[formControlName='monthlyRecurrenceDayNumber']"/>
  <span>{{ 'iss-wo-common.recurrence-schedule.labels.of-every' | translate }}</span>
  <ng-content/>
  <span>{{ 'iss-wo-common.recurrence-schedule.every-recurrence-type.month' | translate }}</span>
</div>
